import { useParams } from "react-router-dom";
import { Stack } from "@volca/ui/components/ui/stack";
import { InternalTransactionsTable } from "@/internal-transactions/internal-transactions-table";
import { useGetInternalTransactions } from "@/internal-transactions/query";

export const InternalTransactions = () => {
  const { businessId } = useParams();
  const { data: internalTransactions = [] } =
    useGetInternalTransactions(businessId);

  return (
    <Stack align="start" gap={4} className="h-full w-full pr-1">
      <InternalTransactionsTable data={internalTransactions} />
    </Stack>
  );
};
